var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _Basic = require("../../../../elements/Basic");

var _PropsHelper = require("../../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Basic/Touchable/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Touchable = function (_React$PureComponent) {
  (0, _inherits2.default)(Touchable, _React$PureComponent);

  var _super = _createSuper(Touchable);

  function Touchable(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Touchable);
    _this = _super.call(this, props);

    _this.onLongPress = function () {
      (0, _PropsHelper.executeFunctionOrUndefined)(_this.props.onLongPress);
    };

    _this.onPress = (0, _debounce.default)(_this.onPress.bind((0, _assertThisInitialized2.default)(_this)), 200, {
      leading: true,
      trailing: false
    });
    _this.onLongPress = _this.onLongPress.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Touchable, [{
    key: "onPress",
    value: function onPress() {
      (0, _PropsHelper.executeFunctionOrUndefined)(this.props.onPress);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          href = _this$props.href,
          NavWrapper = _this$props.NavWrapper,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "href", "NavWrapper"]);

      if (NavWrapper && href) {
        return _react.default.createElement(_Basic.View, (0, _extends2.default)({
          pointer: true
        }, rest, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 43,
            columnNumber: 17
          }
        }), _react.default.createElement(NavWrapper, {
          to: href,
          onPress: this.onPress,
          onContextMenu: this.onLongPress,
          style: {
            width: '100%',
            textDecoration: 'none'
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 44,
            columnNumber: 21
          }
        }, children));
      }

      return href ? _react.default.createElement(_Basic.Clickable, (0, _extends2.default)({
        pointer: true,
        href: href,
        onClick: this.props.skipDebounce ? this.props.onPress : this.onPress,
        onContextMenu: this.onLongPress
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57,
          columnNumber: 13
        }
      }), children) : _react.default.createElement(_Basic.View, (0, _extends2.default)({
        pointer: !!this.props.onPress,
        onClick: this.props.skipDebounce ? this.props.onPress : this.onPress,
        onContextMenu: this.onLongPress
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 67,
          columnNumber: 13
        }
      }), children);
    }
  }]);
  return Touchable;
}(_react.default.PureComponent);

Touchable.propTypes = {
  onPress: _propTypes.default.func,
  onLongPress: _propTypes.default.func,
  skipDebounce: _propTypes.default.bool,
  delayPressIn: _propTypes.default.number,
  href: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  NavWrapper: _propTypes.default.func
};
var _default = Touchable;
exports.default = _default;